export const SEGMENT_COLORS = [
  '#1976D2',
  '#00B8D4',
  '#5C6BC0',
  '#8BC34A',
  '#880E4F',
  '#006A71',
  '#1E2D3D',
] as const;

export function getSegmentColor(index: number): string {
  return SEGMENT_COLORS[Math.abs(index) % SEGMENT_COLORS.length];
}
